<ut-dropdown-menu [items]="items" (selected)="onSelected($event)">
  <button ut-dropdown-trigger type="button" class="language-trigger" aria-label="Language">
    <div class="language-option">
      <div class="fi fi-{{ getFlagFor(lang) }} flag"></div>
    </div>
  </button>
</ut-dropdown-menu>
